import type { HttpClient } from '@remodeling/base';
import querystring from 'query-string';
import {
  GetConstructionCaseCheckCounselorResponse,
  GetConstructionCaseListRequest,
  GetConstructionCaseListResponse,
} from '../../model';

/**
 * 시공사례 목록 조회 API
 *
 * VLOW-160: content-service -> content-info-service 이관.
 * 요청 파라미터와 JSON 구조는 동일하나 데이터소스가 한샘몰 프록시에서
 * 내부 DB 직접 조회로 바뀌어 detailUrl/imageUrl 생성 방식이 달라진다.
 */
export class GetConstructionCaseListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetConstructionCaseListRequest) {
    const query = querystring.stringify(req);
    return await this.httpClient.request<GetConstructionCaseListResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-info-service/api/v1/constructCase?${query}`,
    });
  }
}

/**
 * 전문가 콘텐츠를 파악하는 API
 *
 * VLOW-163: content-service -> content-info-service 이관.
 * 응답 counselorYn 형식이 'true'/'false' 에서 'Y'/'N' 으로 바뀌므로
 * 해석은 parseCounselorYn 을 거쳐야 한다.
 */
export class GetConstructCaseCheckCounselor {
  constructor(readonly httpClient: HttpClient) {}

  async exec() {
    return await this.httpClient.request<GetConstructionCaseCheckCounselorResponse>(
      {
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-info-service/api/v1/constructCase/checkCounselor`,
      },
    );
  }
}
